import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_ORG_ID,
} from 'routes/(global_search_params)/-searchParams'
import { createProcessFlowsSearch } from 'routes/process-flows/-searchParams'
import { Route as NewRoute } from 'routes/process-flows/index'

export const Route = createFileRoute(
  '/process-flows/(deprecated_routes)/$siteID/'
)({
  beforeLoad: ({ params }) => {
    const siteId = params.siteID

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        ...createProcessFlowsSearch({
          orgId: prev[SEARCH_PARAM_ORG_ID],
          siteId,
        }),
      }),
      replace: true,
    })
  },
})
